@if (buttonKey) {
<button
  class="btn btn-primary btn-block"
  [class.disabled]="isDisabled"
  [disabled]="isDisabled"
  [ngClass]="{
    rotating: placeOrderInprogress
  }"
  (click)="onClick()"
>
  {{ placeOrderInprogress ? '' : (buttonKey | cxTranslate) }}
</button>
}
